// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.
import { localEnvironment } from "../../../../libs/menu-shared/src/environments/default-menu.config";

export const environment = {
  production: false,
  imgUrlBase: "",
  apiUrlBase: "",
  defaultLocale: "en-za",
  contentFolder: "/content/tv-guide-v2/",
  debuggingEnabled: true,

  menu: localEnvironment
};

export default environment;